module.exports = __webpack_public_path__ + "e78e0701ba235016f5bd47b3496a1a3d.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-main-1024.webp
// module id = 355
// module chunks = 0